module.exports = __webpack_public_path__ + "img/stone-ditch.31b42a76.jpg";